import { ProspectFilterField } from '../../../types';
import { EmailServiceProvider } from '../../../../../../email-accounts/enums/email-account';
import { getLabelsForProviders } from '../../../../../../../shared/utils/get-email-accounts-esp-mapping';

export const getSelectedOptionKeys = ({
  value,
  field,
}: {
  value: string[];
  field: ProspectFilterField;
}): string[] => {
  if (field?.key === 'emailServiceProvider') {
    return getLabelsForProviders(value as EmailServiceProvider[]) || [];
  }

  if (!value) return [];
  return (value as any[]).map((v) =>
    v === null || typeof v === 'undefined' ? '' : String(v),
  );
};
